import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ReactionLogin.css";

const ReactionLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  useEffect(()=>{

    const authed = localStorage.getItem("rg_auth") === "1";

    if(!authed){
      navigate("/dashboard-login");
    }

  },[navigate]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !phone) {
      setError("Please enter both email and phone number.");
      return;
    }

    try {
      const res = await axios.post("/auth/whitelist-login", {
        email: email.trim(),
        password: phone.trim(),
      });

      if (res.data?.ok) {
        localStorage.setItem("rg_email", email.trim());
        localStorage.setItem("rg_phone", phone.trim());
        localStorage.setItem("rg_auth", "1");
        navigate("/reactiongame/play");
      } else {
        setError("Access restricted. This game is available for bootcamp members. Please purchase to continue.");
      }
    } catch (err) {
      const reason = err?.response?.data?.reason;
      const base = err?.response?.data?.error || "Access restricted. This game is available for bootcamp members. Please purchase to continue.";
      const detail = reason ? ` (Reason: ${reason})` : "";
      setError(base + detail);
    }
  };

  return (
  <div className="rg-login-wrapper">

    {/* ================= REACTION HEADER SECTION ================= */}
    <div className="reaction-header-card">

      <h2 className="reaction-title">Reaction Speed (Simple)</h2>

      <p className="reaction-subtitle">
        Simple reaction speed measures how fast you can respond to a sudden signal — 
        the moment your brain says <strong>“GO”.</strong> It’s a core layer beneath 
        agility, shot timing, saves, and explosive first steps.
      </p>

      <div className="reaction-pill">
        Test type: <strong>Visual stimulus → Single tap response</strong>
      </div>

      <hr className="reaction-divider" />
      {/* ================= WHY SECTION ================= */}
    <div className="reaction-why-card">

      <h3 className="why-title">
        Why reaction speed matters in sport
      </h3>

      <p className="why-description">
        Most game moments are decided in the first few hundred milliseconds.
        Simple reaction speed is your baseline “ignition time” — how quickly your
        nervous system converts a visual cue into action.
      </p>

      <div className="why-tags">
        <span>Faster first step</span>
        <span>Quicker trigger</span>
        <span>Better saves</span>
        <span>Earlier swing / shot</span>
        <span>Less hesitation</span>
      </div>

      <ul className="why-list">
        <li>
          <strong>Time is position.</strong> If you react earlier, you arrive earlier —
          at the ball, the gap, the tackle, the catch.
        </li>
        <li>
          <strong>Reduces “late movement” errors.</strong> Late starts force rushed
          mechanics and poor contact quality.
        </li>
        <li>
          <strong>Improves confidence under pace.</strong> When your baseline trigger
          is quick, you commit sooner and second-guess less.
        </li>
        <li>
          <strong>Shows fatigue & readiness.</strong> Reaction tends to slow with poor
          sleep, overload, dehydration, and mental fatigue.
        </li>
      </ul>

      <hr className="why-divider" />

      <h4 className="sport-title">
        Sport-specific examples
      </h4>

      <ul className="sport-list">
        <li>
          <strong>Cricket/Baseball:</strong> initial trigger on release → better timing
          window and shot selection.
        </li>
        <li>
          <strong>Football/Soccer:</strong> press or intercept on first cue → win duels
          and second balls.
        </li>
        <li>
          <strong>Goalkeepers:</strong> first movement on shot cue → more reach and
          cleaner saves.
        </li>
        <li>
          <strong>Tennis/Badminton:</strong> split-step timing and first push →
          earlier contact point control.
        </li>
      </ul>

    </div>


    </div>
    {/* 🔥 ADD THIS SECTION */}
<div className="how-card">

  <h2 className="how-title">How the game works</h2>

  <ul className="how-list">
    <li>
      When the screen changes (or target appears),
      <strong> tap/click immediately.</strong>
    </li>
    <li>
      You’ll get 5 trials. Reaction time is recorded for each.
    </li>
    <li>
      False starts (clicking before green) don’t count.
    </li>
    <li>
      Reaction speed changes with fatigue, sleep and stress.
    </li>
  </ul>

  <p className="how-note">
    Best practice: use the same device and posture when comparing results.
  </p>

</div>


<div className="game-containerr" style={{ textAlign: "center" }}>
  <h2>Get Ready to Test Your Reaction</h2>

  <p>
    Click Start. Wait for green. Then click as fast as you can.
  </p>

  <button
    onClick={() => navigate("/reactiongame/play")}
    className="start-buttonr"
  >
    Start Game
  </button>

</div>
    
   

  </div>
);};

export default ReactionLogin;
